import React from "react";
import { Dropdown, Menu, Progress, Tooltip, Icon } from "antd";
import moment from "moment";

import { get } from "../utils/utils";
import { Link } from "react-router-dom";
import { roles } from "./../../../configs/constants";

const Indicator = ({ label, number1, number2, total }) => {
  return (
    <div>
      <div className="flex">
        <div className="flex justify-between ga-progress-bar">
          <div className="my-2 text-lg text-gray-700" style={{ width: 150 }}>
            {label}
          </div>
          <span className="my-1 mx-2 w-6 h-6" style={{ width: 300, display: "flex", alignItems: "center" }}>
            <Tooltip placement="top" title={`${number1} à qualifier + ${number2} à valider`}>
              {total > 0 ? (
                <Progress
                  strokeColor={"orange"}
                  percent={((total - number1) * 100) / total}
                  successPercent={((total - (number1 + number2)) * 100) / total}
                  showInfo={false}
                />
              ) : (
                <span>({label === "Forfait repas" ? "pas de forfait repas" : "pas de trajet"})</span>
              )}
            </Tooltip>
          </span>
        </div>
        <div className="my-2 text-lg text-gray-700 font-bold">{`${total - (number1 + number2)} / ${total} `}</div>
      </div>
    </div>
  );
};

const UserPresenceRow = ({ userRoleId, rangeDate, user, exportNDFMealPackagesUser }) => {
  // const presencePendingProcess = get(["attendances", "pending_processed"], user, -1);
  // const presencePendingValidated = get(["attendances", "pending_validated"], user, -1);
  // const totalPresence = get(["attendances", "total"], user, -1);

  const tripPendingProcess = get(["trips", "pending_processed"], user, -1);
  const tripPendingValidated = get(["trips", "pending_validated"], user, -1);
  const totalTrip = get(["trips", "total"], user, -1);

  const mealPackagesPendingProcess = get(["meal_packages", "pending_processed"], user, 0);
  const mealPackagesValidated = get(["meal_packages", "pending_validated"], user, 0);
  const totalMealPackages = get(["meal_packages", "total"], user, 0);

  const userId = get(["user", "id"], user);
  const userFullname = get(["user", "fullname"], user);

  return (
    <tr className="hover:bg-gray-100 cursor-pointer text-gray-700 text-lg">
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
        {user.user.fullname}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-500">
        {/* <Indicator
          label={"Présence"}
          number1={presencePendingProcess}
          number2={presencePendingValidated}
          total={totalPresence}
        /> */}
        <Indicator label={"Trajet"} number1={tripPendingProcess} number2={tripPendingValidated} total={totalTrip} />

        {userRoleId < 4 && user.user && user.user.role_id === roles.TERRAIN && (
          <Indicator
            label={"Forfait repas"}
            number1={mealPackagesPendingProcess}
            number2={mealPackagesValidated}
            total={totalMealPackages}
          />
        )}
      </td>
      <td className="p-6 whitespace-no-wrap border-b border-gray-200 leading-5 text-gray-900 text-right">
        <Link
          className="cursor-pointer underline font-bold text-orange-400 pr-10"
          to={{
            pathname: `/presence/preview/${user && user.user.id}`,
            search: `start_date=${rangeDate[0]}&end_date=${rangeDate[1]}`
          }}
          target="_blank"
        >
          {/*<Link*/}
          {/*  className="cursor-pointer underline font-bold text-orange-400 pr-10"*/}
          {/*  // onClick={() => {*/}
          {/*  //   setUser(user);*/}
          {/*  //   setViewDetail(!viewDetail);*/}
          {/*  // }}*/}
          {/*  to={{*/}
          {/*    pathname: `/presence/preview/${user._id}`*/}
          {/*  }}*/}
          {/*>*/}
          Voir
        </Link>
        {userRoleId <= 2 && (
          <Dropdown
            overlay={
              <Menu
                onClick={({ key }) => {
                  if (key === "export") {
                    exportNDFMealPackagesUser({ userId: userId, userFullname: userFullname });
                  }
                }}
              >
                <Menu.Item key="export">
                  <Icon type="download" /> Téléchargement du récapitulatif des NDF forfait repas par semaine.
                </Menu.Item>
              </Menu>
            }
          >
            <div className={`cursor-pointer underline text-orange-400 pr-10`}>Autres</div>
          </Dropdown>
        )}
      </td>
    </tr>
  );
};

export default UserPresenceRow;



// WEBPACK FOOTER //
// src/modules/presence/components/UserPresenceRow.js